import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { BankIcon } from 'foundations-assets/icons/components/BankIcon';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { GenericLoadingState } from '../components/GenericLoadingState';
import { PAYMENT_METHOD_TYPE } from '../utils/typeAdapters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PaymentMethodsCard({
  paymentMethods = [],
  loading
}) {
  if (loading) {
    return /*#__PURE__*/_jsx(GenericLoadingState, {});
  }
  if (!paymentMethods.length) {
    return /*#__PURE__*/_jsx(EmptyState, {
      flush: true,
      layout: "vertical",
      primaryContent: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "paymentMethods.emptyStateMessage"
      })
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "300",
    children: paymentMethods.map(paymentMethod => /*#__PURE__*/_jsx(PaymentMethodTile, {
      paymentMethod: paymentMethod
    }, paymentMethod.objectId))
  });
}
export function PaymentMethodTile({
  paymentMethod
}) {
  var _brand$toUpperCase;
  const {
    type,
    last4,
    brand
  } = paymentMethod.paymentMethodDetails;
  const {
    storedOn
  } = paymentMethod;
  const isCard = type === PAYMENT_METHOD_TYPE.CARD;
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    borderRadius: "200",
    overflow: "hidden",
    borderWidth: "100",
    borderColor: "border-core-subtle",
    borderStyle: "solid",
    backgroundColor: "fill-surface-default",
    minInlineSize: "280px",
    maxInlineSize: "425px",
    flexBasis: "calc(50% - 12px)",
    flexGrow: 1,
    paddingInline: "700",
    paddingBlock: "400",
    "data-test-id": "payment-method-tile",
    children: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        columnGap: "200",
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(StatusDot, {
          use: "info"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "paymentMethods.stored"
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        columnGap: "200",
        marginBlockEnd: "100",
        children: [isCard ? /*#__PURE__*/_jsx(CreditCardIcon, {
          size: "100"
        }) : /*#__PURE__*/_jsx(BankIcon, {
          size: "100"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "heading-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: isCard && brand ? 'paymentMethods.last4.card' : 'paymentMethods.last4.bank',
            options: {
              brand: (_brand$toUpperCase = brand === null || brand === void 0 ? void 0 : brand.toUpperCase()) !== null && _brand$toUpperCase !== void 0 ? _brand$toUpperCase : '',
              lastFour: last4
            }
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "paymentMethods.storedOn",
          options: {
            date: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: storedOn,
              format: "LL"
            })
          }
        })
      })]
    })
  });
}